var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isUpdate)?_c('PreviewEntrance',{on:{"updateEvent":_vm.updateEvent}}):_c('UpdateEntrance',{on:{"updateEvent":_vm.updateEvent}}),_c('ScrollTopBtn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }